import { InteractiveMap } from "../common/interactiveMap";

export function initDataCenters(razor) {
    new InteractiveMap({
        apiKey: razor.apiKey,
        mapElementId: "map",
        mapId: razor.mapId,
        listElementId: "list",
        listContainerId: "listContainer",
        mapBtnId: "mapBtn",
        listBtnId: "listBtn",
        center: { lat: 65.381, lng: 27.219 },
        zoom: 5,
        maxZoom: 18,
        dataRequest: {
            type: "GET",
            dataType: "json",
            url: "/DataCenterApi/GetDataCenters",
        },

        // #region Site/Map-specific code
        onLoad: function (data) {

            // #region Markers and clusters
            let dataCenters = data.filter(item => !item.isColocation);
            let colocations = data.filter(item => item.isColocation);
            let dcMarkers = this.createMarkers(dataCenters);
            let coMarkers = this.createMarkers(colocations);
            let allMarkers = [].concat(dcMarkers, coMarkers);
            this.createCluster(allMarkers)
            // #endregion

            // #region Site/Map-specific Filters
            // TODO: Might be even better refactored - a litle bit of legacy ahead :)
            // TODO: Consider using some other framework than jQuery (Vue / Svelte / React)

            let activeStars = [1, 2, 3, 4, 5];

            // #region Elements
            const chkBoxDataCenters = $('#investment-opportunities');
            const chkBoxColocations = $('#co-locations');
            // #endregion

            // #region Boundaries
            const getBoundaries = () => {
                return {
                    buildingRights: { from: $('#buildingRightsFrom').val(), to: $('#buildingRightsTo').val() },
                    lotSize: { from: $('#lotSizeFrom').val(), to: $('#lotSizeTo').val() },
                    powerSupply: { from: $('#powerSupplyFrom').val(), to: $('#powerSupplyTo').val() },
                }
            }
            const isIn = (number, boundary) => !(boundary.from > number || boundary.to < number);
            const isWithinBoundaries = (item, boundaries) => {
                if (!boundaries) { boundaries = getBoundaries(); }
                return isIn(item.buildingRight, boundaries.buildingRights)
                    && isIn(item.lotSize, boundaries.lotSize)
                    && isIn(item.totalPowerSupply, boundaries.powerSupply)
                    && activeStars.indexOf(item.investmentReadiness) > -1;
            }
            // #endregion

            // #region Processing filters
            const processDataCenters = () => {
                let show = chkBoxDataCenters.prop('checked');
                let boundaries = getBoundaries();
                dataCenters.forEach((item) => {
                    this.toggleItem(item, show && isWithinBoundaries(item, boundaries));
                });
            }
            const processColocations = () => {
                let show = chkBoxColocations.prop('checked');
                colocations.forEach((item) => {
                    this.toggleItem(item, show);
                });
            }

            this.options.onTabSwitch = () => {
                processDataCenters();
                processColocations();
            }
            // #endregion

            // #region Sliders
            const getUpperLimit = (filter) => {
                var allValues = dataCenters.map(d => d[filter]);
                var maxValue = allValues && allValues.length > 0 ? Math.max(...allValues) : 10000;
                var n = Number(maxValue);
                if (Number.isNaN(n)) {
                    return 10000;
                }
                return n;
            }
            const convertNumberOrString = (value, fraction = 0) => {
                const valueAsNumber = Number(value);
                return !Number.isNaN(valueAsNumber) ? valueAsNumber.toLocaleString("fi-FI", { minimumFractionDigits: fraction, maximumFractionDigits: fraction }).replace(/\,/ig, ".") : "0";
            }
            const createSlider = (key1, key2, key3) => {
                if (key3 == undefined) { key3 = key1; }

                let maxValue = getUpperLimit(key3);
                $('#' + key2 + '-max, #' + key2 + '-above-slider-max').html(convertNumberOrString(maxValue));
                let fromEl = $('#' + key1 + 'From');
                let toEl = $('#' + key1 + 'To');
                let minEl = $('#' + key2 + '-above-slider-min');
                let maxEl = $('#' + key2 + '-above-slider-max');

                const setNumber = (sliderEl, limitEl, value) => {
                    sliderEl.html(convertNumberOrString(value));
                    limitEl.val(value.toString());
                    limitEl.attr('value', value.toString());
                }

                fromEl.attr('max', maxValue);
                fromEl.attr('value', 0);
                fromEl.val(0);
                fromEl.on('input', function (e) {
                    e.preventDefault();
                    let targetValue = Number(e.target.value);
                    let toValue = Number(toEl.val());
                    if (targetValue <= toValue) {
                        setNumber(minEl, fromEl, targetValue);
                    } else {
                        setNumber(minEl, fromEl, toValue);
                    }
                    processDataCenters();
                    return false;
                });

                toEl.attr('max', maxValue);
                toEl.attr('value', maxValue);
                toEl.val(maxValue);
                toEl.on('input', function (e) {
                    e.preventDefault();
                    let targetValue = Number(e.target.value);
                    let fromValue = Number(fromEl.val());
                    if (targetValue !== maxValue && targetValue >= fromValue) {
                        setNumber(maxEl, toEl, targetValue);
                    } else if (targetValue === maxValue) {
                        setNumber(maxEl, toEl, targetValue);
                    }
                    else if (targetValue <= fromValue) {
                        setNumber(maxEl, toEl, fromValue);
                    }
                    processDataCenters();
                    return false;
                });
            }

            const createSliders = () => {
                createSlider('buildingRights', 'building-rights', 'buildingRight');
                createSlider('lotSize', 'lot-size');
                createSlider('powerSupply', 'power-supply', 'totalPowerSupply');
            }
            const resetSlider = (key1, key2, key3) => {
                if (key3 == undefined) { key3 = key1; }

                let maxValue = getUpperLimit(key3);
                $('#' + key2 + '-above-slider-min').html('0');
                $('#' + key2 + '-above-slider-max').html(convertNumberOrString(maxValue));
                $('#' + key1 + 'From').val("0");
                $('#' + key1 + 'To').val(maxValue.toString());
                $('#' + key1 + 'From').attr('value', '0');
                $('#' + key1 + 'To').attr('value', maxValue.toString());
            }
            createSliders();
            // #endregion

            // #region Stars
            let stars = $('.star');
            stars.on('click', function () {
                let star = $(this);
                let idx = parseInt(star.text());

                if (star.hasClass('star' + '-on')) {
                    star.removeClass('star' + '-on');
                    star.addClass('star' + '-off');
                    let i = activeStars.indexOf(idx);
                    if (i > -1) {
                        activeStars.splice(i, 1);
                    }
                } else {
                    star.removeClass('star' + '-off');
                    star.addClass('star' + '-on');
                    if (activeStars.indexOf(idx) < 0) {
                        activeStars.push(idx);
                    }
                }
                processDataCenters();
            });
            // #endregion

            // #region DataCenters and Colocations checkboxes

            chkBoxDataCenters.on("change", processDataCenters);
            chkBoxColocations.on("change", processColocations);
            // #endregion

            // #region Reset filters
            let that = this;
            const resetFilters = () => {
                resetSlider('buildingRights', 'building-rights', 'buildingRight');
                resetSlider('lotSize', 'lot-size');
                resetSlider('powerSupply', 'power-supply', 'totalPowerSupply');

                activeStars = [1, 2, 3, 4, 5];
                $(".star").each(function () {
                    var curStar = $(this);
                    if (curStar.hasClass("star-off")) {
                        curStar.removeClass('star-off');
                    }
                });
                chkBoxDataCenters.prop('checked', true);
                chkBoxColocations.prop('checked', true);
                processDataCenters();
                processColocations();
                that.resetMap();
            }
            $('#reset-all').on('click', resetFilters);
            $('#hide').on("click", function () {
                $('#hideArrowLeft, #hideArrowRight').toggleClass('d-none');
                $('#filters').toggleClass('height-auto');
                $('#reset-all, #co-locations-hide, #accordionExample, #noMargins').toggle('fast');
            });

            // #endregion

            // #region KML Layers
            let kml = {};
            const kmlLayers = razor.kmlLayers;
            for (let name in kmlLayers) {
                kml[name] = { layer: null, kmlFileId: name, kmlUrl: kmlLayers[name] };
                let checkBox = $('#' + name);
                checkBox.on("change", () => {
                    if (checkBox.prop('checked')) {
                        this.showKmlLayer(kml[name]);
                    } else {
                        this.hideKmlLayer(kml[name]);
                    }
                });
                if (checkBox.prop('checked')) {
                    this.showKmlLayer(kml[name]);
                }
            }
            // #endregion

            // #endregion
            processDataCenters();
            processColocations();
        },
        // #endregion

        // #region Templates
        templates: (mapInstance) => {
            return {
                id: (item) => item.id,
                title: (item) => item.name,
                icon: (item) => {
                    // return png images because of recommendation by google to use raster images (pmg or jpg) for markers to avoid lag when map is redrawn.
                    // See more here: https://developers.google.com/maps/optimization-guide#using_raster_images_for_markers
                    return {
                        url: `/img/data-center/pointer-${(item.isColocation ? `lavender` : `blue`)}.png`,
                        scaledSize: new google.maps.Size(41, 49)
                    };
                },
                url: (item) => {
                    return `?name=${item.slug}&id=${item.id}&co=${(item.isColocation ? 1 : 0)}`;
                },
                infoWindow: (item) => {
                    return `<div id="content">
                                ${(item.imageUrl ? `<div id="popup-image"><img loading="lazy" src="${item.imageUrl}" alt="" width="200" height="141"></div>` : ``)}
                                <h4 id="firstHeading" class="firstHeading">
                                    <a href="${mapInstance.templates.url(item)}">${item.name}</a>
                                </h4>
                                <div id="bodyContent">
                                    <span class="list-icon${(item.isColocation ? ` list-icon-colocation` : ``)}"></span>
                                    ${(item.city && item.city !== "" ? `<p>${item.city}</p>` : ``)}
                                </div>
                            </div>`;
                },
                listItem: (item) => {
                    return `<tr class="row-container border-investment-list" id="${item.id}">
                                <td class="mobile-investment-list ${(item.isColocation ? `filter-checkbox-row-co-locations-list` : `filter-checkbox-row-investment-opportunities-list`)}">
                                    <a href="${mapInstance.templates.url(item)}">${item.name}</a>
                                </td>
                                <td class="mobile-colocations-list">
                                    <img loading="lazy" src="/img/data-center/pointer-${(item.isColocation ? `lavender` : `blue`)}.svg" class="pointer-icon-list" width="20" height="20">
                                    ${(item.city && item.city !== "" ? `<span>${item.city}</span>` : ``)}
                                </td>
                            </tr>`;
                }
            }
        }
        // #endregion
    });
}